import script from "./ProjectUpdates.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectUpdates.vue?vue&type=script&setup=true&lang=js"

import "./ProjectUpdates.vue?vue&type=style&index=0&id=7c6db0b2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c6db0b2"]])

export default __exports__